import React from 'react'

import './Tags.scss'

interface TagsProps {
  children: any
}

export const Tags = ({ children }: TagsProps) => <div className="tags">{children}</div>
